import Skeletons from "./Skeletons";
export default Skeletons;
